import { connect, ConnectedProps } from "react-redux";

import { withRouter } from "react-router";
import {
  getVacationRentalShopCallState,
  getVacationRentalShopSelectedListing,
  hasVacationRentalShopFailed,
  VacationRentalShopCallState,
  getShopOffer,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { VRMobileShop } from "./component";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getPetsCount,
  getUntilDate,
} from "../../../search/reducer";
import {
  getOpenDatesModal,
  getIsTravelApp,
} from "../../../availability/reducer";
import { fetchVacationRentalShop } from "../../actions/actions";
import { setIsTravelApp } from "../../../availability/actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  selectedListing: getVacationRentalShopSelectedListing(state),
  vrShopCallInProgress:
    getVacationRentalShopCallState(state) ===
    VacationRentalShopCallState.InProcess,
  hasFailed: hasVacationRentalShopFailed(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildrenCount(state),
  petsCount: getPetsCount(state),
  openDatesModal: getOpenDatesModal(state),
  shopOffer: getShopOffer(state),
  isTravelApp: getIsTravelApp(state),
});

export const mapDispatchToProps = {
  fetchVacationRentalShop,
  setIsTravelApp,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type VRMobileShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedVRMobileShop = withRouter(connector(VRMobileShop));
